import { Component, OnDestroy, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { BusinessEntity } from '../../../models/business-entity';
import { BusinessEntityControllerService } from '../../../services/business-entity-controller.service';
import { ActivatedRoute } from '@angular/router';
import { BPASettings } from '@models/bpa-settings';
import { BpaSettingsService } from '../../../services/bpa-settings.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-dashboard-tabs',
  templateUrl: './dashboard-tabs.component.html'
})
export class DashboardTabsComponent implements OnInit, OnDestroy {
  areBELoaded: boolean = false;
  currentBE: BusinessEntity | null = null;
  businessEntityList: BusinessEntity[] = [];
  USE_BUSINESS_ENTITIES: boolean = environment.USE_BUSINESS_ENTITIES;
  totalFilesCount: number = 0;
  businessEntitiesRefreshInterval: ReturnType<typeof setInterval> | null = null;
  isMyApplicationsBlockOpen: boolean = false;
  private bpaSettingsSubscription?: Subscription;

  constructor(
    public beController: BusinessEntityControllerService,
    private readonly route: ActivatedRoute,
    private readonly bpaSettings: BpaSettingsService
  ) {}

  ngOnInit(): void {
    // Subscribe to BPA settings
    this.bpaSettingsSubscription = this.bpaSettings
      .getBpaSettings$()
      .subscribe((bpaSettings: BPASettings | null) => {
        if (bpaSettings) {
          this.isMyApplicationsBlockOpen = !(
            bpaSettings.displaySystemProperties?.close_applications_list ?? true
          );
        }
      });

    if (this.USE_BUSINESS_ENTITIES) {
      this.getBusinessEntities();
      this.businessEntitiesRefreshInterval = setInterval(() => {
        this.getBusinessEntities();
      }, 15000);
    }
  }

  ngOnDestroy(): void {
    if (this.businessEntitiesRefreshInterval) {
      clearInterval(this.businessEntitiesRefreshInterval);
    }
    if (this.bpaSettingsSubscription) {
      this.bpaSettingsSubscription.unsubscribe();
    }
  }

  private getBusinessEntities() {
    this.beController
      .getBusinessEntities({ skip_files: true })
      .subscribe((result) => {
        this.businessEntityList = result.results;
        this.areBELoaded = true;
      });
  }

  public toggleMyApplicationsBlock() {
    this.isMyApplicationsBlockOpen = !this.isMyApplicationsBlockOpen;
  }

  updateFileCount(totalCount: number) {
    this.totalFilesCount = totalCount;
  }
}
